import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var BluetoothConnected = createReactComponent("BluetoothConnected", ["svg", defaultAttributes, [["path", {
  d: "M7 7l10 10-5 5V2l5 5L7 17",
  key: "1vkd5p"
}], ["line", {
  x1: "18",
  y1: "12",
  y2: "12",
  x2: "21",
  key: "p4cere"
}], ["line", {
  x1: "3",
  y1: "12",
  y2: "12",
  x2: "6",
  key: "1bw2jp"
}]]]);
export default BluetoothConnected;